/*
 *
 * widgetResponseRateReport actions
 *
 */

import {
  GET_DATA_DIVISIONS_RATE_WATCHER,
  GET_DATA_DIVISIONS_RATE_SUCCESS,
  GET_DATA_DIVISIONS_RATE_FAILED,
} from "./constants"

export function getDataDivisionsRateWatcher(payload) {
  return {
    type: GET_DATA_DIVISIONS_RATE_WATCHER,
    payload,
  }
}

export function getDataDivisionsRateSuccess(payload) {
  return {
    type: GET_DATA_DIVISIONS_RATE_SUCCESS,
    payload,
  }
}

export function getDataDivisionsRateFailed() {
  return { type: GET_DATA_DIVISIONS_RATE_FAILED }
}
